import { render, staticRenderFns } from "./Wizardot4draw.vue?vue&type=template&id=64f01fda&scoped=true&"
import script from "./Wizardot4draw.vue?vue&type=script&lang=js&"
export * from "./Wizardot4draw.vue?vue&type=script&lang=js&"
import style0 from "./Wizardot4draw.vue?vue&type=style&index=0&id=64f01fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f01fda",
  null
  
)

export default component.exports